import React from 'react';
import LOGO from '../assets/logo.png';

function Header() {
  const searchSubmit = (e) => {
    e.preventDefault();
    const searchValue = e.target.querySelector('input').value;
    alert(`Frontend Search Simulation: Searching for: ${searchValue}`);
  };

  return (
    <header
  style={{
    position: 'fixed',
    top: 0,
    zIndex: 40,
    width: '100%',
    backgroundColor: 'white',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06)', // shadow-md
  }}
>
  {/* The main container for content, centered and using Flexbox for alignment */}
  <div
    style={{
      maxWidth: '1400px', // max-w-7xl (approx)
      margin: '0 auto', // mx-auto
      padding: '12px 24px', // px-6 py-3 (1rem padding, ~12px vertical)
      display: 'flex', // flex
      alignItems: 'center', // items-center
      justifyContent: 'space-between', // justify-between
    }}
  >
    {/* 1. Logo and Tagline (Left side) */}
    <a
      href="#home"
      style={{
        display: 'flex', // flex
        alignItems: 'center', // items-center
        gap: '12px', // gap-3 (0.75rem)
        textDecoration: 'none', // Remove default link underline
      }}
    >
      <img style={{ width: '80px', height: '80px' }}
        src={LOGO}
        alt="Samudra Logo"  />
      <span
        style={{
          fontSize: '1.875rem', // text-3xl
          fontWeight: '700', // font-bold
          color: 'var(--brand-blue, #004AAD)',
        }}
      >
        SAMUDRA
      </span>
      <span
        style={{
          fontSize: '0.75rem', // text-xs
          color: '#64748b', // text-slate-500
          paddingTop: '4px',
          marginRight: '2px', // pt-1 (0.25rem)
          display: 'block', // Defaulting to always block/visible for simplicity
        }}
      >
        Adjusting & Marine Insurance Solutions
      </span>
    </a>

    {/* 2. Right-hand side group: Nav, Button, Search */}
    <div
      style={{
        display: 'flex', // flex
        alignItems: 'center', // items-center
        gap: '15px', // gap-6 (1.5rem)
      }}
    >
      {/* Navigation Links */}
      <nav
        style={{
          display: 'flex', // flex
          alignItems: 'center', // items-center
          gap: '24px', // gap-6 (1.5rem)
        }}
      >
        <a
          href="#services"
          style={{
            fontSize: '0.875rem', // text-sm
            textDecoration: 'none',
            color: 'inherit',
            fontWeight: '500', // font-medium
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#1d4ed8')} // hover:text-blue-700
          onMouseLeave={(e) => (e.currentTarget.style.color = 'inherit')}
        >
          Services
        </a>
        <a
          href="#claims-center"
          style={{
            fontSize: '0.875rem', // text-sm
            textDecoration: 'none',
            color: 'inherit',
            fontWeight: '500',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#1d4ed8')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'inherit')}
        >
          Claims Center
        </a>
        <a
          href="#credentials"
          style={{
            fontSize: '0.875rem', // text-sm
            textDecoration: 'none',
            color: 'inherit',
            fontWeight: '500',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#1d4ed8')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'inherit')}
        >
          About Us
        </a>
        <a
          href="#contact"
          style={{
            fontSize: '0.875rem', // text-sm
            textDecoration: 'none',
            color: 'inherit',
            fontWeight: '500',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#1d4ed8')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'inherit')}
        >
          Contact Us
        </a>
         <a
          href="./blogs"
          style={{
            fontSize: '0.875rem', // text-sm
            textDecoration: 'none',
            color: 'inherit',
            fontWeight: '500',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#1d4ed8')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'inherit')}
        >
          Blogs
        </a>
      </nav>

      {/* Request Service Button */}
      <a
        href="./claims"
        style={{
          padding: '12px 32px', // py-3 px-8
          color: '#004c8c', // text-white
          fontWeight: '600', // font-semibold
          borderRadius: '0.375rem', // rounded-md
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)', // shadow-lg
          textDecoration: 'none',
          backgroundColor: 'var(--brand-orange, #FFB800)',
          transition: 'background-color 0.15s ease-in-out', // transition duration-150 ease-in-out
          display: 'inline-block', // Important for linking element
        }}
      >
        Request Service
      </a>

      {/* Search Bar */}
      <div
        style={{
          display: 'flex', // flex
          alignItems: 'center', // items-center
          marginLeft: '4px', // ml-2
        }}
      >
        <form
          onSubmit={searchSubmit}
          style={{
            display: 'flex', // flex
            alignItems: 'center', // items-center
            position: 'relative', // relative
          }}
        >
          <input
            style={{
              border: '1px solid #cbd5e1', // border border-slate-300
              borderRadius: '0.375rem 0 0 0.375rem', // rounded-l-md (Rounded left corners only)
              padding: '8px 12px', // py-2 px-3
              fontSize: '0.875rem', // text-sm
              outline: 'none',
              width: '230px', // w-64
              // Styling for focus ring
              WebkitAppearance: 'none',
              MozAppearance: 'none',
              appearance: 'none',
            }}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = '#3b82f6';
              e.currentTarget.style.boxShadow = '0 0 0 1px #3b82f6';
            }} // focus:ring-1 focus:ring-blue-500
            onBlur={(e) => {
              e.currentTarget.style.borderColor = '#cbd5e1';
              e.currentTarget.style.boxShadow = 'none';
            }}
            placeholder="Search Average Adjusting"
          />
          <button
            type="submit"
            style={{
              position: 'absolute',
              right: '0',
              top: '0',
              bottom: '0',
              padding: '8px', // p-2
              color: '#475569', // text-slate-600
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#1d4ed8')} // hover:text-blue-700
            onMouseLeave={(e) => (e.currentTarget.style.color = '#475569')}
          >
            🔍
          </button>
        </form>
      </div>

      {/* Mobile Menu Button (Still commented out) */}
      {/* <button style={{ display: 'none' }} >☰</button> */}
    </div>
  </div>
</header>
  );
}

export default Header;